<template>
  <table class="table table-striped">
    <thead>
    <tr>
      <th>Item</th>
      <th>Buy Price</th>
      <th>Sell Price</th>
      <th>Margin</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="row in sortedRows()">
      <td><img loading="lazy" width="36" height="32"
               :src="`https://raw.githubusercontent.com/osrsbox/osrsbox-db/master/docs/items-icons/${row.id}.png`">
        <p>{{row.name}}</p>
      </td>
      <td>
        <ItemCost :price="row.high"></ItemCost>
      </td>
      <td>
        <ItemCost :price="row.low"></ItemCost>
      </td>
      <td>
        <ItemCost :price="row.margin"></ItemCost>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
  import ItemCost from "./ItemCost";

  export default {
    name: "MarginTable",
    components: {ItemCost},
    props: ['realtimeData', 'itemList', 'minPrice', 'maxPrice', 'maxMargin', 'itemFreshness'],
    methods: {
      sortedRows() {
        let rows = [];
        let checkTime = (Date.now() - (this.itemFreshness * 60 * 1000)) / 1000; //5 mins

        for (const [itemId, price] of Object.entries(this.realtimeData)) {
          let item = this.itemList[itemId];

          if (price.high == null || price.low == null)
            continue;

          if (this.minPrice > 0 && price.low < this.minPrice)
            continue;

          if (this.maxPrice > 0 && price.high > this.maxPrice)
            continue;

          if (this.maxMargin > 0 && (price.low - price.high) > this.maxMargin)
            continue;

          if (this.itemFreshness > 0 && (checkTime > price.highTime || checkTime > price.lowTime))
            continue;

          if (price.low - price.high <= 0)
            continue;

          if (item === undefined)
            item = {
              id: itemId,
              name: "Unknown"
            };

          rows.push({
            id: item.id,
            name: item.name,
            high: price.high,
            low: price.low,
            margin: price.low - price.high
          })
        }

        rows.sort((a, b) => {
          return b.margin - a.margin;
        });

        return rows;
      }
    }
  }
</script>

<style scoped>
  table {
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/margins/MarginTable.vue